<template>
  <pulldown :top-method="topLoadMore" ref="reflash">
    <div slot="top" class="mint-loadmore-top" style="text-align: center;">
      <span :v-show="topStatus == 'loading'">
        <mt-spinner style="snake" color="#ff6634"></mt-spinner>
      </span>
    </div>
    <slot></slot>
  </pulldown>
</template>

<script>
import Pulldown from './pulldown'
export default {
  components: {
    'pulldown': Pulldown
  },
  data () {
    return {
      topStatus: ''
    }
  },

  props: {
    'topMethod': {
      type: Function
    },
    'bottomMethod': {
      type: Function
    }
  },

  methods: {
    topLoadMore () {
      this.topMethod(this.$refs.reflash.onloaded)
    },

    handleTopChange (status) {
      this.topStatus = status
    }
  }
}
</script>

<style>
.mint-loadmore-top div, .mint-loadmore-bottom div{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// loadmore.vue?3753d0b2